<template>
    <div 
        v-if="hasHeader || showImportantDisclosure" 
        class="mb-3 d-flex justify-content-between align-items-start align-items-md-center flex-column flex-md-row gap-2" 
        :class="{ 'mb-md-5': hasHeader }"
    >
        <h2 v-if="hasHeader" class="mb-3 mb-md-0">{{ h2 }}</h2>
        <important-disclosure v-if="showImportantDisclosure" />
    </div>
</template>

<script>
import ImportantDisclosure from '@/components/ImportantDisclosure.vue';

export default {
    components: {
        ImportantDisclosure
    },
    props: {
        h2: {
            type: String,
            required: true
        },
        showImportantDisclosure: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        hasHeader() {
            return this.h2.length > 0;
        }
    }
};
</script>